import { UserApplicationProperties } from './user-application-properties.model';
import { BaseUser } from './base-user.model';
import { Application } from 'app/shared/services/app/application/application.model';

export class GlobalUser extends BaseUser {
  applications: Application[] = [];
  appHash: any = {};
  roles: UserApplicationProperties[] = [];
  company: string = '';

  permissions: any[] = [];
  canCreateApps: boolean = false;

  isPending: boolean;
  isLocked: boolean;

  constructor(json?: any) {
    super(json || null);
    if (json) {
      this.company = json.company || '';

      this.permissions = json.permissions || [];
      this.canCreateApps = json.permissions && this.permissions.indexOf('create_apps') > -1;

      this.isPending = json.is_new_user || false;
      this.isLocked = json.is_locked || false;
    }
  }

  hasApplication(sysName: string): boolean {
    return this.appHash[sysName];
  }

  toJson() {
    let json: any = {
      id: this.id,
      first_name: this.lastName,
      last_name: this.lastName,
      email: this.email,
      company: this.company,
      apps: this.roles.map(role => role.toJson()),
      permissions: this.permissions,
      is_new_user: this.isPending,
      is_locked: this.isLocked
    };
    return json;
  }

  copy() {
    return new GlobalUser(this.toJson());
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/user/global-user.model.ts